module.exports = __webpack_public_path__ + "static/media/04-galeria-03-santa-fe-mobile@2x.a428c9bb.jpg";